import { LambdaClient } from "@aws-sdk/client-lambda";
import { S3Client, S3ClientConfig } from "@aws-sdk/client-s3";
import { fromCognitoIdentityPool } from "@aws-sdk/credential-providers";
import { ProjectSession } from "../projects/ProjectsSlice";

const REGION = "eu-central-1";
const IDENTITY_POOL_ID = "eu-central-1:2974072e-822b-4a89-beb2-5448e0eb327e";
const IDP = `cognito-idp.${REGION}.amazonaws.com/eu-central-1_FNBiIwCvA`;

type ClientInstance<T, P = string> = {
  params: P;
  client: T;
}

export class ClientFactory {
  private static instance = new ClientFactory();
  private lambdaClient: ClientInstance<LambdaClient> | null = null;

  public static getInstance(): ClientFactory {
    return this.instance;
  }

  public getLambdaClient(token: string): LambdaClient {
    if (!this.lambdaClient || this.lambdaClient.params !== token) {
      this.lambdaClient = {
        params: token,
        client: new LambdaClient({
          region: REGION,
          credentials: fromCognitoIdentityPool({
            identityPoolId: IDENTITY_POOL_ID,
            clientConfig: { region: REGION },
            logins: {
              [IDP]: token,
            },
          }),
        })
      };
    }
    return this.lambdaClient.client;
  }

  public getS3Client(
    sessionToken: ProjectSession,
    extraOptions?: Partial<S3ClientConfig>
  ): S3Client {
    return new S3Client({
      region: REGION,
      credentials: {
        accessKeyId: sessionToken.AccessKeyId,
        secretAccessKey: sessionToken.SecretAccessKey,
        sessionToken: sessionToken.SessionToken,
      },
      ...extraOptions,
    });
  }
}